/*************************************************/
/* INVIEW                                        */
/*************************************************/
import inView from "../vendor/in-view.min.js";

export function inview() {

    const inViewActiveClass = "in-view";

    const init = function () {
        const elements = [
            {
                selector: ".banner",
                offset: -350
            }, {
                selector: "#roomVideo",
                offset: 0
            }];
        
        for (var i = 0; i < elements.length; i++) {
            const current = elements[i];
            inView.offset(current.offset);
            inView(current.selector).on("enter", function (t) {
                $(current.selector).trigger('addedInViewClass');
                return t.classList.add(inViewActiveClass);
            }).on("exit", function (t) {
                //return t.classList.remove(inViewActiveClass);
            });
        }
    };

    init();
}